import {
    deletePromoterSection,
    getPromoterSections,
    savePromoterSection,
    updatePromoterSection
} from "../../helpers/promoterSectionService";
import {checkError, closeAlert, receiveErrorAlert, receiveSuccessAlert} from "../commonsActions";

export const FETCH_PROMOTER_SECTIONS_BEGIN = 'FETCH_PROMOTER_SECTIONS_BEGIN';
export const FETCH_PROMOTER_SECTIONS_SUCCESS = 'FETCH_PROMOTER_SECTIONS_SUCCESS';
export const FETCH_PROMOTER_SECTIONS_ERROR = 'FETCH_PROMOTER_SECTIONS_ERROR';

/*
 * action creators
 */

const fetchPromoterSectionsSuccess = res => ({
    type: FETCH_PROMOTER_SECTIONS_SUCCESS,
    payload: {
        promoterSections: res.data,
        numberOfElements: res.numberOfElements,
        totalElements: res.totalElements,
        totalPages: res.totalPages
    }
});

const fetchPromoterSectionsError = error => ({
    type: FETCH_PROMOTER_SECTIONS_ERROR,
    payload: {
        error: error,
    }
});

export const fetchPromoterSections = query => dispatch => {
    dispatch({type: FETCH_PROMOTER_SECTIONS_BEGIN});
    return getPromoterSections(query).then(res => {
        dispatch(fetchPromoterSectionsSuccess(res));
        return res;
    }, error => {
        dispatch(fetchPromoterSectionsError(error))
        dispatch(checkError(error));
        dispatch(receiveErrorAlert(error));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
    })
};

export const saveNewPromoterSection = section => dispatch => {
    return savePromoterSection(section).then(res => {
        dispatch(receiveSuccessAlert('Success'));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
        return res;
    })
};

export const updateSinglePromoterSection = section => dispatch => {
    return updatePromoterSection(section).then(res => {
        dispatch(receiveSuccessAlert('Update Successful'));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
        return res;
    })
};

export const removePromoterSection = sectionId => dispatch => {
    return deletePromoterSection(sectionId).then(res => {
        return res;
    }, error => {
        dispatch(checkError(error));
        dispatch(receiveErrorAlert(error));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
    })
};


// WEBPACK FOOTER //
// ./src/actions/promoter/promoterSectionActions.js